import React from 'react';
import { PieChart } from 'components/Charts';
import { Col, Row } from 'reactstrap';
import classnames from 'classnames';
import './ProgressCircle.scss';
import variables from 'scss/1-settings/colors.scss';
import PropTypes from 'prop-types';

const colorOptions = {
  primary: variables.primary,
  secondary: variables.secondary,
  success: variables.success,
  info: variables.info,
  warning: variables.warning,
  danger: variables.danger,
  light: variables.light,
  dark: variables.dark,
};

function ProgressCircle(props) {
  const { children, color, icon, showValue, stacked, value } = props;

  const data01 = [
    { value, fill: colorOptions[color] },
    { value: 100 - value, fill: 'rgba(125, 125, 125, 0.15)' },
  ];
  return (
    <Row
      className={classnames('progress-circle', 'align-items-center', {
        stacked,
      })}
    >
      <Col xs={12} md={!stacked && 6} className="circle-container">
        <PieChart
          aspect={1}
          data={data01}
          innerRadius={stacked ? '90%' : '85%'}
          label={false}
          outerRadius="100%"
          showLegend={false}
          tooltip={false}
          endAngle={180}
          startAngle={540}
        />
        <div className="headline-figure" style={{ color: colorOptions[color] }}>
          {icon} {showValue && `${value}%`}
        </div>
      </Col>
      <Col xs={12} md={!stacked && 6}>
        {children}
      </Col>
    </Row>
  );
}

ProgressCircle.propTypes = {
  /** Content inside the circle */
  children: PropTypes.node,
  /** Bootstrap color */
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'info',
    'warning',
    'danger',
    'light',
    'dark',
  ]),
  /** Icon to be placed beside the value */
  icon: PropTypes.node,
  /** Show the value inside the progress circle */
  showValue: PropTypes.bool,
  /** Place the children below the circle, instead of to the right */
  stacked: PropTypes.bool,
  /** Progress value */
  value: PropTypes.number.isRequired,
};

ProgressCircle.defaultProps = {
  children: null,
  color: 'primary',
  icon: null,
  showValue: true,
  stacked: false,
};

export default ProgressCircle;
